module.exports = __webpack_public_path__ + "/static/assets/a4451ef35d29c4997f7c8e837da8af44.svg";